export enum UnitDepositAccountStatus {
  None = 0,
  Open = 1,
  Closed = 2,
  Frozen = 3,
  Closing = 4
}

export namespace UnitDepositAccountStatus {
  export function toString(status: UnitDepositAccountStatus): string {
    switch (status) {
      case UnitDepositAccountStatus.None:
        return 'None';
      // case UnitDepositAccountStatus.Open:
      //   return 'Open';
      case UnitDepositAccountStatus.Frozen:
        return 'Frozen';
      case UnitDepositAccountStatus.Closed:
      case UnitDepositAccountStatus.Closing:
        return 'Closed';
      default:
        return '';
    }
  }

  export function parse(str: string): UnitDepositAccountStatus {
    return UnitDepositAccountStatus[str];
  }

  export function getClassStatus(status: UnitDepositAccountStatus) {
    if (!!status) {
      switch (status) {
        case UnitDepositAccountStatus.Open:
          return '';
        case UnitDepositAccountStatus.Frozen:
        case UnitDepositAccountStatus.Closed:
        case UnitDepositAccountStatus.Closing:
          return 'error';
        default:
          return 'neutral';
      }
    }
    return 'neutral';
  }

  export function getIconStatus(status: UnitDepositAccountStatus) {
    if (status) {
      switch (status) {
        // case UnitDepositAccountStatus.Open:
        //   return 'check_circle';
        case UnitDepositAccountStatus.Frozen:
        case UnitDepositAccountStatus.Closed:
        case UnitDepositAccountStatus.Closing:
          return 'do_not_disturb_on';
      }
    }
    return '';
  }
}

export default UnitDepositAccountStatus;
